module.exports = __webpack_public_path__ + "static/media/appalti-privati.422c6473.jpg";